module.exports = __webpack_public_path__ + "static/media/download-main-img.c2199912.png";